
<template>
    <div>

        <v-overlay :value="showOverlay" class="text-center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

            <p class="text-caption text-light mt-10">Importing in Progress . . .</p>
        </v-overlay>


        <v-card elevation="0" height="310" class="pa-4 text-center">

            <v-card-text v-if="!uploading" class="pa-2">

                <p class="text-caption text-light ma-0">Start import {{ this.termlabel }} - individual who purchases goods,
                    services, or
                    advice from teachers, doctors, coaches etc.
                </p>

                <v-btn class="ma-2" small plain color="indigo" @click="downloadStudentsTemplate">
                    <v-icon>mdi-download</v-icon>
                    Download excel template file
                </v-btn>

                <v-file-input :label="'Import ' + this.termlabel" v-model="importFileStudents" @change="parseStudentsFile"
                    accept=".xlsx,.xls,.csv"></v-file-input>

                <v-btn v-if="ParsedStudents" class="ma-2" small plain color="indigo" @click="toImportStudentsDialog = true">
                    <v-icon>mdi-magnify-plus-outline</v-icon>
                    Preview to Import ( {{ this.termlabel }})
                </v-btn>

                <v-btn v-if="ParsedStudents" block color="primary" rounded x-large @click="startImporting">
                    Start Import
                </v-btn>

            </v-card-text>


            <v-card-action>

                <v-btn v-if="uploading" class="ma-2" small plain color="indigo" @click="importStatusDialog = true">
                    <v-icon>mdi-chart-donut</v-icon>
                    Import status Report
                </v-btn>
            </v-card-action>


        </v-card>

        <v-row justify="center">
            <v-dialog v-model="toImportStudentsDialog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Import {{ this.termlabel }} </span>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="StudentsTableHeaders" :items="StudentsTableItems"
                            class="elevation-1"></v-data-table>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="toImportStudentsDialog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>



        <v-row justify="center">
            <v-dialog v-model="importStatusDialog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Import Status Report - Students</span>
                    </v-card-title>
                    <v-card-text>

                        <div v-if="uploading">

                            <p> {{ this.termlabel }} Uploaded: {{ uploadedCount }}</p>
                            <p>Failed Uploads: {{ failedStudents.length }}</p>

                            <p>Items with issue/s: {{ itemsWithIssueCount }}</p>

                            <v-card v-if="failedStudents.length" elevation="1">
                                <v-simple-table fixed-header height="300px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    {{ this.termlabel }}
                                                </th>
                                                <th class="text-left">
                                                    Reasons
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(failure, index) in failedStudents" :key="index">
                                                <td>{{ failure.student.firstName }} {{ failure.student.lastName }} ({{
                                                    failure.student.email
                                                }}) </td>
                                                <td>{{ failure.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="importStatusDialog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import Papa from 'papaparse';

import { mask } from "vue-the-mask";
import { rules } from "@/store/util/rules.js";
import "vue-tel-input/dist/vue-tel-input.css";

export default {
    name: 'StudentImport',
    props: {
        centers: { type: Array, required: true },
        termlabel: { type: String, required: true }
    },
    data() {
        return {
            rules,
            toImportStudentsDialog: false,
            importFileStudents: null,
            StudentsContent: [],
            ParsedStudents: false,
            StudentsTableHeaders: [],
            StudentsTableItems: [],
            importStatusDialog: false,
            uploading: false,
            uploadedCount: 0,
            itemsWithIssueCount: 0,
            failedStudents: [],
            showOverlay: false

        };
    },
    watch: {
        StudentsParsed(val) {
            console.log(val)
        },
    },
    directives: { mask },
    computed: {
        ...mapGetters("terminology", ["terminologies"]),
        ...mapGetters("navigation", ["globalCenter"]),

    },
    methods: {
        ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
        ...mapActions("student", ["createStudent"]),

        parseStudentsFile() {
            Papa.parse(this.importFileStudents, {
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    this.StudentsContent = results;
                    this.ParsedStudents = true;

                    this.StudentsContent.meta.fields.forEach((item) => {
                        const _header = { text: item, value: item }
                        this.StudentsTableHeaders.push(_header);
                    })

                    this.StudentsContent.data.forEach((item) => {
                        const _item = {
                            // center: item.center,
                            firstname: item.firstname,
                            lastname: item.lastname,
                            email: item.email,
                            phone: item.phone,
                            about: item.about,
                            gender: item.gender,
                        }
                        this.StudentsTableItems.push(_item);
                    })

                }.bind(this)
            });
        },

        removeDuplicatesAndEmptyRows(list) {
            const seen = new Set();

            return list.filter(item => {
                const emailKey = item.email || '';
                const phoneKey = item.phone || '';

                // Remove row if all keys are empty
                if (!emailKey.trim() && !phoneKey.trim()) {
                    return false;
                }

                // Check if any of the keys have been seen before
                if (seen.has(emailKey) || seen.has(phoneKey)) {
                    return false;
                }

                // If not, add the keys to the set and include the item in the result
                seen.add(emailKey);
                seen.add(phoneKey);
                return true;
            });
        },

        startImporting() {
            this.showOverlay = true;
            this.uploading = true;
            const filteredList = this.removeDuplicatesAndEmptyRows(this.StudentsTableItems);
            const chunkSize = 10;

            // Split the filtered list into chunks of 10
            for (let i = 0; i < filteredList.length; i += chunkSize) {
                const chunk = filteredList.slice(i, i + chunkSize);

                // Iterate through each chunk and send requests
                chunk.forEach((item) => {
                    const student = {
                        centerId: item.center,
                        firstName: item.firstname,
                        lastName: item.lastname,
                        email: item.email,
                        phone: item.phone,
                        clientStudentId: '',
                        gender: item.gender,
                        contactId: null,
                        memo: "",
                        dob: "",
                        grade: "",
                        contactTypeId: 127,
                        active: true,
                    };
                    this.addNewStudent(student);
                })

                this.showOverlay = false;

            }

            this.itemsWithIssueCount = this.StudentsTableItems.length - filteredList.length;
            const a = this.failedStudents.length / 100;
            this.failedPercentage = a * filteredList.length;
        },
        async addNewStudent(newStudent) {
            const savedStudent = await this.importStudent(newStudent);
            if (savedStudent) {
                this.uploadedCount++;
            }
        },
        async importStudent(student) {
            debugger;
            return await this.$axios
                .post("/student/v2", student)
                .then((resp) => {
                    debugger;
                    const savedStudent =
                        resp.data && resp.data.data ? resp.data.data : null;
                    return savedStudent;
                })
                .catch((error) => {

                    debugger;
                    this.failedStudents.push({ student, reason: error.data.message });
                });
        },
        downloadStudentsTemplate() {
            const url = '/downloads/students.csv';
            window.location.href = url;
        }
    },
};
</script>
